const selectShowModal = (state) => state.modal.show;
const selectShowMobileMenu = (state) => state.modal.showMobileMenu;

export { selectShowMobileMenu, selectShowModal };
//# sourceMappingURL=modal.js.map
